import { render, staticRenderFns } from "./BasicStats.vue?vue&type=template&id=24d64159&scoped=true&"
import script from "./BasicStats.vue?vue&type=script&lang=js&"
export * from "./BasicStats.vue?vue&type=script&lang=js&"
import style0 from "./BasicStats.vue?vue&type=style&index=0&id=24d64159&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d64159",
  null
  
)

export default component.exports